import { throwHttpError } from "./errors";

class RegisterService {
  API: string;

  constructor() {
    this.API = process.env.REACT_APP_PUBLIC_AUTH_ENDPOINT || '';
  }

  async register(values: any, reCaptchaToken: string, dest?: string): Promise<any> {
    const query = dest ? `?${new URLSearchParams({ dest }).toString()}` : '';
    return fetch(`${this.API}${query}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'recaptcha-token': reCaptchaToken,
      },
      body: JSON.stringify(values),
    })
      .then(throwHttpError)
      .then((res) => res.json())
      .then((res) => {
        return { type: 'success', result: res };
      })
      .catch((err: any) => {
        const status = err.status;
        const message = err.res?.message;

        if (status === 409) {
          return {
            type: 'error',
            result: {
              message: [
                `${message || 'Account already exists.'} Redirecting to login...`,
              ],
              response: 'redirect-login',
            },
          };
        }

        return {
          type: 'error',
          result: {
            message: Array.isArray(message)
              ? message
              : [message || 'Something went wrong'],
          },
        };
      });
  }

  async resendEmailVerification(email: string, dest?: string): Promise<any> {
    const params = new URLSearchParams({ email });
    if (dest) {
      params.set('dest', dest);
    }
    return fetch(`${this.API}/evt?${params.toString()}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(throwHttpError)
      .then((res) => res.json())
      .catch((err: any) => {
        return { type: 'error', result: err.res || { message: 'Unable to send email verification!' } };
      });
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RegisterService();